let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2KOut")).then(() => parcelRequire('iBF9X'));